<template lang="pug">
  div.container-fluid.background-login.vertical-center.px-0
    div.row.d-flex.justify-content-center
      div.col-12.col-sm-12.col-md-6.col-lg-6
        div.card
          div.spinner.spinner-border.spinner-border-lg.text-primary(v-if="settingPassword")
          div.card-header
            | Kennwort eingeben
          div.card-body(:class="{ invisible: settingPassword }")
            form(@submit.prevent)
              div.form-group
                label(for="password")
                  | Kennwort
                input.form-control(
                  type="password"
                  id="password"
                  placeholder="Geben Sie Ihr neues Kennwort ein"
                  v-model="password"
                  :disabled="settingPassword"
                  @keyup.enter="login"
                  )
              div.form-group
                label(for="passwordRepated")
                  | Kennwort bestätigen
                input.form-control(
                  type="password"
                  id="passwordRepated"
                  placeholder="Geben Sie Ihr neues Kennwort nochmal ein"
                  v-model="passwordRepated"
                  :disabled="settingPassword"
                  @keyup.enter="setPassword"
                  )
              div
                button.mx-3.btn.btn-primary.btn-lg(
                  type="button"
                  @click.stop="setPassword"
                  :disabled="!canSetPassword"
                  )
                  | Neues Kennwort setzen
                button.mx-3.btn(
                  type="button"
                  @click.stop="goBack"
                  v-if="!showSuccess"
                  )
                  | Abbrechen
                button.mx-3.btn.btn-secondary(
                  type="button"
                  @click.stop="showLogin"
                  v-if="showSuccess"
                  )
                  | Weiter
              div.mt-4.pa-2.alert.alert-danger(v-if="showError")
                | {{ errorMessage }}
              div.mt-4.pa-2.alert.alert-success(v-if="showSuccess")
                div
                  | Ihre Kennwort wurde geändert.
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SetNewPassword',
  data: () => ({
    errorMessage: '',
    password: '',
    passwordRepated: '',
    showError: false,
    showSuccess: false
  }),
  computed: {
    ...mapState({
      settingPassword: state => !!state.orderFormService.loadingIndicators.saveNewPassword
    }),
    canSetPassword () {
      return !(this.showError || this.showSuccess || !this.hasPassword)
    },
    hasPassword () {
      return this.password !== ''
    },
    samePasswordEntered () {
      return this.password !== '' && this.password === this.passwordRepated
    },
    token () {
      return this.$route.query.token
    }
  },
  watch: {
    password () {
      this.clearError()
      this.checkSamePassword()
    },
    samePasswordEntered () {
      this.checkSamePassword()
    }
  },
  methods: {
    ...mapActions('authentication', [
      'setNewPassword'
    ]),
    ...mapActions('ui', [
      'goBack',
      'showLogin',
      'showStartPage'
    ]),
    checkSamePassword () {
      if (!this.samePasswordEntered) {
        this.errorMessage = 'Die Kennwörter müssen identisch sein.'
        this.showError = true
      } else {
        this.showError = false
      }
    },
    clearError () {
      this.showError = false
      this.showSuccess = false
    },
    async setPassword () {
      this.clearError()
      this.showSuccess = await this.setNewPassword({
        token: this.token,
        password: this.password
      })
      this.showError = !this.showSuccess
      if (this.showError) {
        this.errorMessage = 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
      }
    }
  }
}
</script>
